import { Drawer } from '@/components/ui';
import { Section, defineSection } from '@decify/cell-shopify/client';
import './menu-drawer.scss';
class MenuDrawer extends Section {
    constructor() {
        super('MenuDrawer');
    }
    onSectionSelect() {
        this.drawerElement.open();
    }
    onSectionDeselect() {
        this.drawerElement.close();
    }
    get drawerElement() {
        const drawerElement = this.querySelector('cell-component-drawer');
        if (!drawerElement) {
            throw new Error('Drawer element not found');
        }
        if (!(drawerElement instanceof Drawer)) {
            throw new Error('Drawer element is not an instance of Drawer');
        }
        return drawerElement;
    }
}
defineSection('cell-section-menu-drawer', MenuDrawer);
